import { rootState, StarlinkPool } from "@/types/store/state";

const setObject = function (key: string, value: any) {
  if (!key || !value) {
    return;
  }

  if (typeof value === "object") {
    value = JSON.stringify(value);
  }
  localStorage.setItem(key, value);
};
const getObject = function <T>(key: string): T | null {
  var value = localStorage.getItem(key);

  if (value === null) {
    return null;
  }

  try {
    return JSON.parse(value) as T;
  } catch (error) {
    //Failing means it was a simple string
    return value as unknown as T;
  }
};

const createFleetMenu = (state: rootState, pools: StarlinkPool[] = []) => {
  state.links[1].children = [];
  state.links[1].children.push({ name: "performance", url: { name: "Performance" } });

  const hasStarlinkEquipment =
    state.company?.modems && Array.isArray(state.company.modems.Starlink)
      ? state.company.modems.Starlink.length > 0
      : true;

  if (hasStarlinkEquipment) {
    state.links[1].children.push({
      name: "starlink.fleetUsage",
      url: { name: "StarlinkFleetUsage" },
    });
  }

  if (pools.length || state.starlinkPools.length) {
    state.links[1].children.push({
      name: "starlinkPoolsUsage.name",
      url: { name: "StarlinkPoolUsage" },
    });
  }
};

export { setObject, getObject, createFleetMenu };
